import Vue from 'vue';
const initialFilter = {
  PhoneId: null,
  fromDate: null,
  toDate: null,
};
export default {
  data() {
    return {
      searchTitle: '',
      tableHeaders: [
        {
          text: 'کد',
          value: 'phoneCode',
          width: '80px',
        },
        {
          text: 'زمان شروع',
          value: 'startDate',
          width: '180px',
        },
        // {
        //   text: "زمان پایان",
        //   value: "endDate",
        //   width:'180px'
        // },
        {
          text: 'زمان take off به محل سوختگیری',
          value: 'takeOffToPlace',
        },

        {
          text: 'زمان landing در محل سوختگیری',
          value: 'landingInPlace',
        },
        {
          text: 'زمان take off از محل سوخت گیری',
          value: 'landingInPlace',
        },
        {
          text: 'زمان استقرار در پایگاه',
          value: 'arriveToStation',
        },
        {
          text: 'اعزام به ماموریت هوایی',
          value: 'dispatchToMission',
        },
      ],
      hasSearch: false,
      filterData: initialFilter,
      isFilterModalOpen: false,
      isDetailModalOpen: false,
      detailId: null,
      pagination: {
        pageNumber: 1,
        pageSize: 10,
        totalItems: 0,
      },
    };
  },
  computed: {
    hasSearch: function () {
      return Object.values(this.filterData)?.some((value) => !!value);
    },
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      this.getRefuelList();
      this.getAllPhones();
    },
    transformRefuelList: function (refuelList) {
      return [...refuelList]?.map((item) => ({
        id: item?.id,

        startDate: item?.phoneActivity?.startDate
          ? Vue.moment(item?.phoneActivity?.startDate).format('jYYYY/jMM/jDD-hh:mm:ss')
          : '-',
        takeOffToPlace: item?.takeOffToPlace
          ? Vue.moment(item?.takeOffToPlace).format('jYYYY/jMM/jDD-hh:mm:ss')
          : '-',
        landingInPlace: item?.landingInPlace
          ? Vue.moment(item?.landingInPlace).format('jYYYY/jMM/jDD-hh:mm:ss')
          : '-',
        takeOffFromPlace: item?.takeOffFromPlace
          ? Vue.moment(item?.takeOffFromPlace).format('jYYYY/jMM/jDD-hh:mm:ss')
          : '-',
        arriveToStation: item?.arriveToStation
          ? Vue.moment(item?.arriveToStation).format('jYYYY/jMM/jDD-hh:mm:ss')
          : '-',
        dispatchToMission: item?.dispatchToMission
          ? Vue.moment(item?.dispatchToMission).format('jYYYY/jMM/jDD-hh:mm:ss')
          : '-',
        endDate: item?.endDate ? Vue.moment(item?.endDate).format('jYYYY/jMM/jDD-hh:mm:ss') : '-',
        phoneCode: item?.phoneActivity?.phone?.code ?? '-',
      }));
    },
    openFilterModal: function () {
      this.isFilterModalOpen = true;
    },
    closeFilterModal: function () {
      this.isFilterModalOpen = false;
    },
    openDetailModal: function (id) {
      this.detailId = id;
      this.isDetailModalOpen = true;
    },
    closeDetailModal: function () {
      this.isDetailModalOpen = false;
      this.detailId = null;
    },
    setPagination: function (data) {
      this.pagination.totalItems = data?.totalItems;
    },
    resetPageNumber: function () {
      this.pagination.pageNumber = 1;
    },
    onGettingList: function () {
      const params = {
        ...this.filterData,
        ...this.pagination,
      };
      this.getRefuelList(params);
    },
    setFilter: function (filterData) {
      this.resetPageNumber();
      this.filterData = filterData;
      this.onGettingList();
      this.closeFilterModal();
    },
    clearFilter: function () {
      this.filterData = initialFilter;
    },
  },
};
